<template>
  <div>
    <slot v-if="voteAuth" name="voteMain" ref="voteMain" />
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'

export default {
  name: 'vote-base',
  mixins: [Error],
  data () {
    return {
      voteAuth: false
    }
  },
  created () {
    this.$ajax.get(api.getAdminLoginInfo()).then((data) => {
      this.$store.dispatch('setUser', data.admin_info)
      let userInfo = data.admin_info
      if (!userInfo.vote) {
        this.$message.error('暂无点赞中心权限')
        this.$router.push({name: 'welcome-list'})
      } else {
        this.voteAuth = true
      }
    }, (res) => {
      this.$store.dispatch('setUser', null)
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Base.vue?b94c34a4